import * as React from 'react';
import {FunctionComponent} from 'react';
import {observer} from 'mobx-react-lite';
import {classNames} from '../support/classnames';
import {Employee} from '../../models/employee';
import {User} from '../../models/user';
import {PresenterProps, withPresenter} from '../support/with_presenter';
import {EmployeeRowPresenter} from './employee_row_presenter';
import {SprintCell} from './sprint_cell';

interface OwnProps {
    compact: boolean;
    user: User;
    now: Date;
    employee: Employee;
    dates: Date[];
}

const EmployeeRowComponent: FunctionComponent<OwnProps & PresenterProps<EmployeeRowPresenter>> = observer(
    ({presenter, user, now, employee, dates, compact}) => {
        const sprints = presenter.sprints;
        if (sprints === null) {
            return null;
        }

        const isMe = user.employee_id === employee.id;
        return (
            <tr className={classNames({active: isMe})}>
                <td>{isMe ? <strong>{employee.name}</strong> : employee.name}</td>
                {dates.map((date) => {
                    return (
                        <SprintCell
                            key={date.toDateString()}
                            now={now}
                            compact={compact}
                            date={date}
                            sprints={sprints}
                            employee={employee}
                            employeeAvailabilities={presenter.availabilities}
                        />
                    );
                })}
            </tr>
        );
    },
);

export const EmployeeRow = withPresenter<EmployeeRowPresenter, OwnProps>(
    (props, component) =>
        new EmployeeRowPresenter(props.employee.id, component.sprintsRepository, component.availabilitiesRepository),
    EmployeeRowComponent,
);
